export default {
    'general': {
        'update': 'Update',
        'move': 'Move',
        'dashboard': 'Dashboard',
        'email': 'Email',
        'username': 'Username',
        'name': 'Name',
        'password': 'Password',
        'actions': 'Actions',
        'login': 'Login',
        'logout': 'Logout',
        'no_results': 'No results',
        'success': 'Success',
        'warning': 'Warning',
        'remember_me': 'Remember me',
        'error': 'Error',
        'edit': 'Edit',
        'details': 'Details',
        'add': 'Add',
        'delete': 'Delete',
        'yes': 'Yes',
        'no': 'No',
        'cancel': 'Cancel',
        'back': 'Back',
        'image': 'Image',
        'filters': 'Filters',
        'remove_filters': 'Remove filters',
        'default': 'Default',
        'save': 'Save',
        'key': 'Key',
        'distribution_zone': 'Distribution zone',
        'preview': 'Preview',
        'icon': 'Icon',
        'last_edited': 'Last edited',
        'unknown': 'Unknown',
        'confirm': 'Confirm',
        'show_more': 'Show more',
        'show_less': 'Show less',
        'deleted': 'Deleted',
        'unlimited': 'Unlimited',
        'domain': 'Domain',
        'type': 'Type',
        'enable': 'enable',
        'disable': 'disable',
        'enabled': 'Enabled',
        'disabled': 'Disabled',
        'slug': 'Slug',
        'check': 'Check',
        'ok': 'OK',
        'not_ok': 'Not OK',
        'close': 'Close',
        'generate': 'Generate',
        'uploaded': 'Uploaded',
        'audio': 'Audio',
        'video': 'Video',
        'status': 'Status',
        'refresh': 'Refresh',
        'hour': 'Hour',
        'week': 'Week',
        'month': 'Month',
        'copy': 'Copy',
        'value': 'Value',
        'level': 'Level',
        'sec': 'sec',
        'day': 'day | days',
        'min': 'min',
        'h': 'h'
    },
    'languages': {
        'english': 'English',
        'croatian': 'Croatian'
    },
    'watch_statistics': {
        'watch_statistics': 'Watch statistics',
        'no_data': 'No data for selected range',
        'daily_watch': 'Daily watch',
        'active_connections': 'Active connections',
        'average_connections': 'Average connections',
        'watch_minutes': 'Watch minutes',
        'watch_users': 'Watch users'
    },
    'errors': {
        'generic_error': 'There was an error',
        'login': 'There was an error logging in',
        'logout': 'There was an error logging out',
        'incorrect_password': 'The old password is incorrect',
        'username_taken': 'Username is taken',
        'invalid_data': 'Invalid data received',
        'not_found': 'Data not found',
        'user_exist': 'User with this username already exists',
        'load_data': 'There was an error loading data',
        'on_upload_image': 'There was an error uploading images',
        'on_upload_file': 'There was an error uploading files',
        'on_add': 'There was an error adding',
        'on_edit': 'There was an error editing',
        'on_delete': 'There was an error deleting',
        'on_sort': 'There was an error sorting',
        'unauthorized': 'Unauthorized',
        'user_does_not_exist': 'User does not exists',
        'role_exists': 'Role exists',
        'role_does_not_exist': 'role does not exists',
        'unable_to_retrieve_extension': 'Unable to retrieve extension',
        'channel_category_is_applied_at_channel': 'Channel category is applied at channel',
        'distribution_zone_applied_at_worker': 'Distribution zone is applied at worker',
        'file_to_big': 'File is to big',
        'missing_roles': 'Missing roles',
        'no_roles_selected': 'User must have at least one role selected',
        'fetching_data': 'Error fetching data',
        'deleting_default_data': 'Error deleting default data',
        'data_already_exists': 'Data already exists',
        'external_id_exists': 'Client with given External ID already exists',
        'client_does_not_exist': 'Client does not exist',
        'distribution_zone_in_use': 'Distribution zone is in use',
        'package_already_activated': 'Package already activated',
        'package_valid_until_must_be_after_current_time': 'Package valid until must be after current time',
        'package_is_not_activated': 'Package is not activated',
        'invalid_domain': 'Invalid domain',
        'cant_toggle_enabled_default_distribution_zone': 'You can not toggle enabled field at default distribution zone',
        'max_allowed_devices_reached': 'You have reached max allowed devices on this client',
        'failed_to_insert': 'Failed to insert',
        'profile_in_use': 'Profile is in use',
        'live_media_source_for_channel_with_profile_exists': 'Live media source for the channel with profile already exists',
        'channel_in_use': 'Channel is in use',
        'load_user_data': 'There was an error loading your data. Please log out and log back in. If the problem persists, contact your administrator!',
        'on_copy_to_clipboard': 'Error copying to clipboard',
        'channel_mapping_already_exists': 'Channel mapping already exists',
        'wrong_provider': 'Wrong provider',
        'wrong_challenge_type': 'Wrong challenge type',
        'slug_exists': 'This slug already exists. Please use different slug.',
        'username_exists': 'This username already exists. Please use different username.',
        'agreement_required': 'Agreement is required',
        'max_allowed_devices_lower_than_active_devices': 'Max allowed devices ({max_allowed_devices}) is lower than currently active devices ({active_devices}).',
        'api_key_name_exists': 'API Key with the given name already exists',
        'channel_with_position_exists': 'Channel with position already exists',
        'position_must_be_between_1_and_999': 'Position must be between 1 and 999',
        'worker_name_exists': 'Worker name already exists'
    },
    'warn_message': {
        'generated_key': 'You will not be able to access this key after you close this dialog!',
        'displayed_to_user': 'Displayed to user on TV',
        'no_roles_selected': 'User must have at least one role selected',
        'copy_to_clipboard_error': 'Error copying text to clipboard',
        'api_key_name_exists': 'API Key with given name already exists',
        'api_key_expired': 'API Key is expired',
        'certificate_expiring': 'Certificate will expire soon or is already expired. Contact your administrator.',
        'api_key_no_roles_selected': 'API key must have at least one role selected'
    },
    'success': {
        'on_update': 'Successfully updated',
        'on_add': 'Successfully added',
        'on_edit': 'Successfully edited',
        'on_delete': 'Successfully deleted',
        'on_sort': 'Successfully sorted',
        'on_change_password': 'The password has been successfully changed',
        'channel_package_activated': 'Channel package successfully activated',
        'channel_package_deactivated': 'Channel package successfully deactivated',
        'device_activated': 'Device successfully activated',
        'device_deactivated': 'Device successfully deactivated',
        'on_copy_to_clipboard': 'Copied to clipboard!'
    },
    'confirmations': {
        'general': 'Are you sure you want to proceed?',
        'header': 'Are you sure',
        'delete_row': 'Are you sure you want to delete',
        'deactivate_row': 'Are you sure you want to deactivate'
    },
    'table': {
        'no_data': 'No data to display',
        'press_enter_search': 'Press enter to search',
        'search': 'Search by',
        'select_option': 'Select option',
        'select_date': 'Select date',
        'select_range': 'Select range',
        'of': 'of'
    },
    'profile': {
        'profile': 'Profile',
        'edit_profile': 'Edit profile',
        'old_password': 'Old password',
        'new_password': 'New password',
        'confirm_password': 'Confirm password',
        'change_password_text': 'If password field is empty, password will not be changed.',
        'change_password': 'Change password'
    },
    'file': {
        'drag_and_drop': 'Drag and drop files to here to upload.'
    },
    'user': {
        'users': 'Users',
        'name': 'Name',
        'username': 'Username',
        'created': 'Created',
        'roles': 'Roles',
        'add': 'Add user',
        'edit': 'Edit user',
        'password': 'Password',
        'confirm_password': 'Confirm password',
        'delete': 'user',
        'cannot_edit_username': 'Username cannot be edited'
    },
    'channel_category': {
        'channel_categories': 'Channel categories',
        'channel_category': 'Channel category',
        'add': 'Add channel category',
        'edit': 'Edit channel category',
        'delete': 'channel category'
    },
    'channel_package': {
        'channel_packages': 'Channel packages',
        'channel_package': 'Channel package',
        'add': 'Add channel package',
        'edit': 'Edit channel package',
        'delete': 'channel package',
        'channels': 'Channels',
        'selected_channels': 'Selected channels',
        'search_channels': 'Search channels',
        'clients_with_activated_channel_package': 'Clients with activated channel package ({0})',
        'delete_clients_text': 'Are you sure you want to delete the channel package? This will deactivate package on all clients that use this channel package.',
        'active_channel': 'Active channel on channel package'
    },
    'channel': {
        'auto_select': 'Auto select',
        'channel': 'Channel | Channels',
        'add': 'Add channel',
        'edit': 'Edit channel',
        'logo': 'Logo',
        'display_name': 'Display name',
        'delete': 'channel',
        'delete_channel_text': 'Do you really want to delete channel?',
        'active_sources_on_channel_text': 'Active live media sources on channel',
        'delete_text': {
            'in_use': 'Channel in use',
            'are_you_sure': 'Are you sure you want to delete the channel?',
            'this_will_delete': 'This action will delete',
            'sources': 'all active live media sources on this channel',
            'packages': 'channel from all channel packages',
            'epgs': 'channel epg mappings and channel epg entries'
        },
        'delete_sources_text': 'Are you sure you want to delete the channel? This will delete all active live media sources on this channel.',
        'delete_package_text': 'Are you sure you want to delete the channel? This will remove channel from all channel packages.',
        'delete_sources_package_text': 'Are you sure you want to delete the channel? This will delete all active live media sources on this channel and remove channel from all channel packages.',
        'delete_sources_text_2': 'Before deleting, you can check the active live media sources in the table.',
        'used_in': 'This channel is being used. Check following components:',
        'watch_statistics': {
            'watch_statistics': 'Channel watch statistics',
            'no_data': 'No data for selected range',
            'active_connections': 'Active connections',
            'top_clients': 'Top clients'
        },
        'adult_only': 'Adult only',
        'are_you_sure_you_want_to_change_channel_to_no_longer_have_parental_controls': 'Are you sure you want to change the channel to no longer have parental controls?',
        'position': 'Position',
        'sort_channels': 'Sort channels',
        'view_currently_sorted_channels': 'View currently sorted channels',
        'online_offline_channels': 'Online / offline channels',
        'online': 'Online',
        'drm': {
            'channel_drm': 'Channel DRM',
            'edit_config': 'Edit config',
            'checkbox': 'Enable DRM',
            'config': 'Channel DRM Config',
            'hdcp_level': 'HDCP Level',
            'resource_rating': 'Resource Rating',
            'device_security_level': 'Device Security Level',
            'type': 'Type',
            'disable_err': 'To edit channel DRM enable global DRM config',
            'hdcp_msg': {
                'security_level': 'WV Security Level ',
                'option1': 'HDCP_NONE',
                'msg1': 'HDCP not specified1',
                'option2': 'HDCP_V1',
                'msg2': 'Enforce HDCP 1.x Playback not allowed if Client does not report HDCP 1.x or better.',
                'option3': 'HDCP_V2',
                'msg3': 'Enforce HDCP 2.0 Playback not allowed if Client does not report HDCP 2.0 or better.',
                'option4': 'HDCP_V2_1',
                'msg4': 'Enforce HDCP 2.1 Playback not allowed if Client does not report HDCP 2.1 Type 1 or better.',
                'option5': 'HDCP_V2_2',
                'msg5': 'Enforce HDCP 2.2 Playback not allowed if Client does not report HDCP 2.2 Type 1 or better.',
                'option6': 'HDCP_V2_3',
                'msg6': 'Enforce HDCP 2.3 Playback not allowed if Client does not report HDCP 2.3 Type 1 or better.',
                'option7': 'HDCP_NO_DIGITAL_OUTPUT',
                'msg7': 'No digital output allowed, including HDCP. Internal display only.'
            },
            'resource_msg': {
                'description1': 'The goal of having several levels of performance for the Widevine CDM is to easily allow applications and content providers to decide which quality of content to serve to each device. OEMCrypto will report a performance level that it supports, and applications and content providers may use these ratings to make easier business decisions.',
                'description2': 'This parameter is exposed by OEMCrypto 15 or later (equivalent to client version 15 or later).',
                'option1': 'Resource Rating Tier',
                'msg1': 'Example Device',
                'option2': '1 - Low',
                'msg2': 'A low cost phone that only plays SD would probably be in this tier.',
                'option3': '2 - Medium',
                'msg3': 'A high cost phone that only plays SD or HD would probably be in this tier.',
                'option4': '3 - High',
                'msg4': 'A UHD television or home entertainment device would probably be in this tier.',
                'option5': '4 - Very High',
                'msg5': 'An 8k television or home entertainment device would probably be in this tier.'

            },
            'security': {
                'option1': 'SW_SECURE_CRYPTO',
                'msg1': 'Secure decryption in software is required. This matches Widevine L3.',
                'option2': 'SW_SECURE_DECODE',
                'msg2': 'Media data is to be decoded securely in software. This matches Widevine L3.',
                'option3': 'HW_SECURE_CRYPTO',
                'msg3': 'Secure decryption in hardware is required. This matches Widevine L2.',
                'option4': 'HW_SECURE_DECODE',
                'msg4': 'Media data is to be decoded securely in hardware. This matches Widevine L1.',
                'option5': 'HW_SECURE_ALL',
                'msg5': 'The media pipeline must be decrypted and decoded securely in hardware. This matches Widevine L1.'

            },
            'not_set': 'NOT_SET',
            'low': 'Low',
            'high': 'High',
            'medium': 'Medium',
            'very_high': 'Very High'
        }
    },
    'timeshift': {
        'title': 'Timeshift',
        'valid_units': 'Valid units: {0} (day, hour, minute, second).',
        'decimals_not_allowed': 'Decimals are not allowed.',
        'invalid_character_error': 'Only numbers and \'d\', \'h\', \'m\', \'s\' units are allowed.',
        'number': 'number',
        'unit': 'unit',
        'invalid_format_error': 'Units must be in form of',
        'duplicated_unit_error': 'The unit {0} is duplicated.',
        'update_timeshift': 'Update timeshift',
        'recording_time': 'Recording time',
        'active': 'Active',
        'delete': 'channel',
        'reformat_time': 'Reformat time',
        'recording_time_must_be_set': 'Recording time must be set to activate timeshift.',
        'timeshift': {
            'title': 'Timeshift',
            'valid_units': 'Valid units: {0} (day, hour, minute, second).',
            'decimals_not_allowed': 'Decimals are not allowed.',
            'invalid_character_error': 'Only numbers and {0} units are allowed.',
            'number': 'number',
            'unit': 'unit',
            'invalid_format_error': 'Units must be in form of',
            'duplicated_unit_error': 'The unit {0} is duplicated.',
            'update_timeshift': 'Update timeshift',
            'recording_time': 'Recording time',
            'active': 'Active',
            'delete': 'channel',
            'reformat_time': 'Reformat time',
            'recording_time_must_be_set': 'Recording time must be set to activate timeshift.'
        },
        'auto_select': 'Auto select'
    },
    'roles': {
        'dashboard': 'Dashboard',
        'client_configuration': 'Client configuration',
        'configuration': 'Configuration',
        'drm_configuration': 'Drm configuration',
        'drm_global_configuration': 'Global DRM configuration',
        'drm_channel_configuration': 'Channel DRM configuration',
        'epg_blackout': 'EPG blackout',
        'read': 'Read',
        'write': 'Write',
        'select_all': 'Select all',
        'remove_all': 'Remove all'
    },
    'distribution_zone': {
        'distribution_zones': 'Distribution zones',
        'distribution_zone': 'Distribution zone',
        'add': 'Add distribution zone',
        'edit': 'Edit distribution zone',
        'delete': 'distribution zone',
        'default_zone_warning': 'Current default distribution zone is set to {0}. Are you sure you want to change it?',
        'active_clients_on_distribution_zone': 'Active clients on distribution zone ({0})',
        'delete_clients_text': 'Are you sure you want to delete the distribution zone? This will unassign zone on all clients that use this distribution zone.',
        'enable_channel_pick': 'Enable channel pick',
        'all_channels': 'all channels',
        'enable': 'Enable',
        'disable': 'Disable',
        'resetAll': 'Reset all fields',
        'toggleEnabledAllMsg': 'Are you sure you want to {toggle} all channels?',
        'resetAllMsg': 'Are you sure you want to reset all fields on all channels?',
        'streaming_channels': 'Streaming channels',
        'streaming_not_enabled': 'Channel streaming is not enabled.',
        'no_channels': 'No channels',
        'auto_select': 'Auto select',
        'timeshift_channels': 'Timeshift channels',
        'online_distribution_zones': 'Online Distribution zones',
        'offline_distribution_zones': 'Offline distribution zones'
    },
    'client': {
        'clients': 'Clients',
        'client': 'Client',
        'add': 'Add client',
        'edit': 'Edit client',
        'name': 'Name',
        'username': 'Username',
        'email': 'Email',
        'password': 'Password',
        'change_password': 'Change password',
        'language': 'Language',
        'external_id': 'External ID',
        'parental_control_code': 'Parental control code',
        'max_number_of_devices': 'Max number of devices',
        'max_number_of_live_connections': 'Max number of live connections',
        'created_at': 'Created',
        'created_by': 'Created by',
        'delete': 'client',
        'last_edited_at': 'Last edited at',
        'last_edited_by': 'Last edited by',
        'package_activation': {
            'channel_packages': 'Channel packages',
            'channel_packages_activation': 'Channel packages activation',
            'package_name': 'Package name',
            'status': 'Status',
            'activation_time': 'Activation time',
            'valid_until': 'Valid until',
            'created_at': 'Created at',
            'valid': 'Active',
            'not_valid': 'Not Active',
            'expired': 'Expired',
            'activate': 'Activate',
            'deactivate': 'Deactivate',
            'deactivated': 'Deactivated',
            'no_activation': 'No activation',
            'pending_activation': 'Pending activation',
            'extend': 'Extend',
            'activate_from_now': 'Activate from now',
            'activate_channel_package': 'Activate channel package',
            'extend_channel_package_activation': 'Extend channel package activation',
            'activation_duration': 'Activation duration',
            'activation_will_be_valid_until': 'Activation will be valid until',
            'number': 'number',
            'unit': 'unit',
            'invalid_format_error': 'Unit must be in form of',
            'duplicated_unit_error': 'The unit d is duplicated.',
            'activation_will_expire_on': 'Activation will expire on',
            'delete': 'activation for package',
            'previous_and_future_activations': 'Previous and future activations',
            'deactivate_package_for_user': 'Deactivate package for user',
            'deactivate_all_activations': 'Are you sure you want to deactivate package {0}? This will deactivate current and all future activations!',
            'deactivate_single_activation': 'Are you sure you want to deactivate package {0}.',
            'activate_from_now_message': 'This activation will be active only until next activation'
        },
        'devices': {
            'devices': 'Devices',
            'add': 'Add device',
            'deactivate': 'Deactivate',
            'deactivate_device': 'Are you sure you want to deactivate {device}?',
            'waiting_adoption': 'Waiting for adoption to complete',
            'successfully_adopted': 'Device successfully adopted',
            'last_seen_at': 'Last seen',
            'name': 'Name',
            'device': 'Device',
            'status': 'Status',
            'code': 'Code',
            'type': 'Device type',
            'os': 'OS',
            'os_version': 'OS version',
            'app_version': 'App version',
            'statuses': {
                'adopted': 'Adopted',
                'deactivated': 'Deactivated'
            },
            'types': {
                'tv': ' TV',
                'mobile': 'Mobile',
                'desktop': 'Desktop',
                'tablet': 'Tablet',
                'unknown': 'Unknown'
            }
        },
        'watch_statistics': {
            'watch_statistics': 'Client watch statistics',
            'no_data': 'No data for selected range',
            'watch_time': 'Watch time',
            'top_channels': 'Top channels'
        }
    },
    'live_media': {
        'title': 'Live media',
        'profile_audio': 'Live media audio profile | Live media audio profiles',
        'profile_video': 'Live media video profile | Live media video profiles',
        'profile': 'Live media profile | Live media profiles',
        'source': 'Live media source | Live media sources',
        'source_type': 'Source type',
        'video_profile': 'Video profile | Video profiles',
        'audio_profile': 'Audio profile | Audio profiles',
        'add_profile': 'Add live media profile',
        'edit_profile': 'Edit live media profile',
        'add_source': 'Add live media source',
        'edit_source': 'Edit live media source',
        'color': 'Color',
        'url': 'URL',
        'audio_url': 'Audio URL',
        'separate_audio': 'Separate audio',
        'active_profile_on_channel_text': 'Active channels on profile',
        'delete_profile_and_sources_text': 'Are you sure you want to delete the profile? This will delete all live media sources on all used channels.',
        'source_delete_text': 'live media source for channel {channel_name} with profile {live_media_profile_name}'
    },
    'worker': {
        'workers': 'Workers',
        'worker': 'Worker',
        'add': 'Add worker',
        'edit': 'Edit worker',
        'delete': 'worker',
        'generate': 'Generate key',
        'regenerate': 'Regenerate key',
        'generated': 'Generated key',
        'key_already_generated': 'Key is already generated',
        'delete_key': 'Another key for this worker exists. Are you sure you want to delete old key and generate new?',
        'info': 'Worker info',
        'no_info': 'There is no information about this worker yet.',
        'processor': 'Processor',
        'processor_cores': 'Processor cores',
        'ram': 'RAM',
        'partitions': 'Partitions',
        'swap': 'SWAP',
        'ip': 'IP',
        'port': 'Port',
        'enable_https_config': 'Enable HTTPS config',
        'enabled_https_config': 'Enabled HTTPS config',
        'behind_tls_terminating_reverse_proxy': 'Behind TLS terminating reverse proxy',
        'metrics': 'Metrics',
        'no_data': 'No data for selected range',
        'cpu_load_cores': 'CPU cores load',
        'cpu_load_avg': 'CPU average load',
        'avg1': 'Average 1min',
        'avg5': 'Average 5min',
        'avg15': 'Average 15min',
        'read': 'Read',
        'write': 'Write',
        'usage': 'Usage',
        'used': 'Used',
        'memory_usage': 'Memory usage',
        'swap_usage': 'Swap usage',
        'interfaces_sent': 'Interfaces - sent',
        'interfaces_received': 'Interfaces - received',
        'operations': 'Read/write - {name}',
        'used_disc': 'Used - {name}',
        'outdated_config_text': 'Worker uses outdated TLS configuration',
        'type': 'Worker type',
        'types': {
            'streaming': 'Streaming',
            'timeshift': 'Timeshift'
        },
        'status': {
            'certificate_status': 'Certificate status',
            'tls_status': 'TLS status',
            'undefined': 'Undefined',
            'provisioning': 'Provisioning',
            'provisioned': 'Provisioned',
            'provision_error': 'Provision error',
            'enabled': 'Enabled',
            'disabled': 'Disabled'
        },
        'online': 'Online',
        'offline': 'Offline'
    },
    'ranges': {
        '1h': 'Last hour',
        '6h': 'Last 6 hours',
        '24h': 'Last 24 hours',
        '7d': 'Last 7 days',
        '30d': 'Last 30 days',
        'selectRange': 'Select range',
        'start': 'Start',
        'end': 'End',
        'predefined': 'Predefined options'
    },
    'prime_vue': {
        'startsWith': 'Starts with',
        'contains': 'Contains',
        'notContains': 'Not contains',
        'endsWith': 'Ends with',
        'equals': 'Equals',
        'notEquals': 'Not equals',
        'noFilter': 'No Filter',
        'lt': 'Less than',
        'lte': 'Less than or equal to',
        'gt': 'Greater than',
        'gte': 'Greater than or equal to',
        'dateIs': 'Date is',
        'dateIsNot': 'Date is not',
        'dateBefore': 'Date is before',
        'dateAfter': 'Date is after',
        'clear': 'Clear',
        'apply': 'Apply',
        'matchAll': 'Match All',
        'matchAny': 'Match Any',
        'addRule': 'Add Rule',
        'removeRule': 'Remove Rule',
        'accept': 'Yes',
        'reject': 'No',
        'choose': 'Choose',
        'upload': 'Upload',
        'cancel': 'Cancel',
        'completed': 'Completed',
        'pending': 'Pending',
        'fileSizeTypes': ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        'dayNames': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        'dayNamesShort': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        'dayNamesMin': ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        'monthNames': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        'monthNamesShort': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        'chooseYear': 'Choose Year',
        'chooseMonth': 'Choose Month',
        'chooseDate': 'Choose Date',
        'prevDecade': 'Previous Decade',
        'nextDecade': 'Next Decade',
        'prevYear': 'Previous Year',
        'nextYear': 'Next Year',
        'prevMonth': 'Previous Month',
        'nextMonth': 'Next Month',
        'prevHour': 'Previous Hour',
        'nextHour': 'Next Hour',
        'prevMinute': 'Previous Minute',
        'nextMinute': 'Next Minute',
        'prevSecond': 'Previous Second',
        'nextSecond': 'Next Second',
        'am': 'am',
        'pm': 'pm',
        'today': 'Today',
        'weekHeader': 'Wk',
        'dateFormat': 'mm/dd/yy',
        'weak': 'Weak',
        'medium': 'Medium',
        'strong': 'Strong',
        'passwordPrompt': 'Enter a password',
        'searchMessage': '{0} results are available',
        'selectionMessage': '{0} items selected',
        'emptySelectionMessage': 'No selected item',
        'emptySearchMessage': 'No results found',
        'fileChosenMessage': '{0} files',
        'noFileChosenMessage': 'No file chosen',
        'emptyMessage': 'No available options',
        'aria': {
            'trueLabel': 'True',
            'falseLabel': 'False',
            'nullLabel': 'Not Selected',
            'star': '1 star',
            'stars': '{star} stars',
            'selectAll': 'All items selected',
            'unselectAll': 'All items unselected',
            'close': 'Close',
            'previous': 'Previous',
            'next': 'Next',
            'navigation': 'Navigation',
            'scrollTop': 'Scroll Top',
            'moveTop': 'Move Top',
            'moveUp': 'Move Up',
            'moveDown': 'Move Down',
            'moveBottom': 'Move Bottom',
            'moveToTarget': 'Move to Target',
            'moveToSource': 'Move to Source',
            'moveAllToTarget': 'Move All to Target',
            'moveAllToSource': 'Move All to Source',
            'pageLabel': 'Page {page}',
            'firstPageLabel': 'First Page',
            'lastPageLabel': 'Last Page',
            'nextPageLabel': 'Next Page',
            'prevPageLabel': 'Previous Page',
            'rowsPerPageLabel': 'Rows per page',
            'jumpToPageDropdownLabel': 'Jump to Page Dropdown',
            'jumpToPageInputLabel': 'Jump to Page Input',
            'selectRow': 'Row Selected',
            'unselectRow': 'Row Unselected',
            'expandRow': 'Row Expanded',
            'collapseRow': 'Row Collapsed',
            'showFilterMenu': 'Show Filter Menu',
            'hideFilterMenu': 'Hide Filter Menu',
            'filterOperator': 'Filter Operator',
            'filterConstraint': 'Filter Constraint',
            'editRow': 'Row Edit',
            'saveEdit': 'Save Edit',
            'cancelEdit': 'Cancel Edit',
            'listView': 'List View',
            'gridView': 'Grid View',
            'slide': 'Slide',
            'slideNumber': '{slideNumber}',
            'zoomImage': 'Zoom Image',
            'zoomIn': 'Zoom In',
            'zoomOut': 'Zoom Out',
            'rotateRight': 'Rotate Right',
            'rotateLeft': 'Rotate Left'
        }

    },
    'metrics_suffixes': {
        'bytes': 'Bytes',
        'kb': 'KB',
        'mb': 'MB',
        'gb': 'GB',
        'tb': 'TB'
    },
    'epg': {
        'providers': 'EPG providers',
        'provider': 'EPG provider',
        'add': 'Add EPG provider',
        'edit': 'Edit EPG provider',
        'delete': 'EPG provider',
        'type': 'EPG type',
        'update_interval': 'Update interval (min)',
        'channels_used': 'Channels used',
        'url': 'URL',
        'available_epg_channels': 'Available EPG channels',
        'provider_title': 'Provider',
        'last_entry': 'Last entry',
        'thumbnail_percentage': 'Thumbnail percentage',
        'update_in_progress': 'Update in progress',
        'last_update': 'Last update',
        'entries': 'EPG Entries',
        'start_time': 'Start time',
        'end_time': 'End time',
        'remove_epg_data': 'Remove EPG Data',
        'remove_epg_data_text': 'Do you really want to remove EPG Data?',
        'blackout': 'Mark as blackout',
        'blackout_clear': 'Clear blackout',
        'blackout_badge': 'BLACKOUT',
        'blackout_confirm': 'This program will be marked as blackout and excluded from recordings. If a recording is currently in progress it will be stopped immediately.',
        'blackout_reason_label': 'Reason (optional)',
        'blackout_reason_placeholder': 'e.g. contractual restriction',
        'blackout_success': 'EPG entry marked as blackout',
        'blackout_error': 'Failed to mark EPG entry as blackout',
        'blackout_clear_confirm': 'Clear the blackout for this program? It will become recordable again.',
        'blackout_clear_success': 'Blackout cleared',
        'blackout_clear_error': 'Failed to clear blackout',
        'selected_epg_type_is_not_correct': 'Selected EPG type is not correct',
        'mapping': {
            'provider_mappings': 'EPG Provider mappings',
            'add': 'Add mapping',
            'edit': 'Edit mapping',
            'delete': 'Mapping',
            'provider_id': 'Provider EPG ID',
            'channel_name': 'Channel name',
            'max_days': 'Max Days',
            'not_available_channel_text': 'A channel that is no longer available from the provider is being used',
            'active': 'Active EPG mappings'
        },
        'insecure': 'Insecure',
        'secure_connection': 'Secure connection',
        'allow_insecure': 'Allow insecure connections'
    },
    'tls_configuration': {
        'configuration': 'TLS configuration | TLS configurations',
        'add': 'Add TLS configuration',
        'edit': 'Edit TLS configuration',
        'delete': 'TLS configuration for domain',
        'delete_workers_text': 'Are you sure you want to delete TLS configuration? This will remove TLS configuration from all workers that use it.',
        'workers_with_tls_config': 'Workers with TLS configuration',
        'domain': 'Domain',
        'agree_to_terms_and_conditions': 'I Agree to Let’s Encrypt terms and conditions:',
        'challenge_type': 'Challenge type',
        'provider': 'Provider',
        'documentation': 'Documentation',
        'cloudflare': {
            'show_dns_token_and_zone_token': 'Show DNS API token and zone API token',
            'cf_api_email': 'Cloudflare email',
            'cf_api_key': 'Cloudflare API key',
            'cf_dns_api_token': 'Cloudflare DNS API token',
            'cf_zone_api_token': 'Cloudflare zone API token'
        },
        'google_domains': {
            'google_domains_access_token': 'Google Domains access token'
        },
        'google_cloud': {
            'gce_project': 'GCE project',
            'gce_service_account': 'GCE service account (JSON file)'
        },
        'go_daddy': {
            'go_daddy_api_key': 'Go Daddy API key',
            'go_daddy_api_secret': 'Go Daddy API secret'
        },
        'namecheap': {
            'namecheap_api_key': 'Namecheap API key',
            'namecheap_api_user': 'Namecheap API user'
        },
        'status': {
            'title': 'Status',
            'created': 'Created',
            'provisioning': 'Provisioning',
            'provisioned': 'Provisioned',
            'provision_error': 'Provision error'
        },
        'select_all': 'Select all',
        'remove_all': 'Remove all'
    },
    'api_key': {
        'api_keys': 'API Keys',
        'api_key': 'API Key',
        'name': 'Name',
        'key_expires': 'Key expires',
        'expiration': 'Expiration',
        'add': 'Add API Key',
        'delete': 'API Key',
        'your_api_key': 'Your API Key',
        'creation_notice': 'Notice: you can view your created API Key only this time. After you close this window, you will not be able to see or get the key again.',
        'expired': 'Expired',
        'valid': 'Valid',
        'expires_soon': 'Expires Soon',
        'no_expiration': 'No Expiration',
        'created_by': 'Created by',
        'created_at': 'Created at',
        'roles': 'Roles'
    },
    'weekdays': {
        'monday': 'Mon',
        'tuesday': 'Tue',
        'wednesday': 'Wed',
        'thursday': 'Thur',
        'friday': 'Fri',
        'saturday': 'Sat',
        'sunday': 'Sun'
    },
    'session': {
        'session': 'Session',
        'shaka_cmd': 'Shaka command',
        'ffmpeg_cmds': 'FFMPEG commands',
        'session_id': 'Session ID',
        'start_time': 'Start time',
        'end_time': 'End time',
        'channel_id': 'Channel ID',
        'worker_id': 'Worker ID',
        'distribution_zone_id': 'Distribution Zone ID',
        'channel_name': 'Channel name',
        'worker_name': 'Worker name',
        'distribution_zone_name': 'Distribution Zone name',
        'session_stop': 'Session stop reason',
        'created_offline': 'Created while disconnected',
        'session_active': 'Active',
        'channel': 'Channel',
        'worker': 'Worker',
        'distribution_zone': 'Distribution Zone',
        'worker_logs': 'Worker logs',
        'session_table': 'Session Table',
        'channel_table': 'Channel sessions',
        'distribution_zone_table': 'Distribution zone sessions',
        'worker_table': 'Worker sessions',
        'copy_stream_dash': 'Copy stream DASH',
        'copy_stream_hls': 'Copy stream HLS',
        'timeshift': 'Timeshift recording sessions',
        'epg': 'EPG',
        'duration': 'Duration',
        'status': 'Status',
        'title': 'EPG title',
        'epg_id': 'EPG ID',
        'recording_details': 'Recording details',
        'recording_start_time': 'Recording start time',
        'recording_end_time': 'Recording end time',
        'epg_start_time': 'EPG start time',
        'epg_end_time': 'EPG end time',
        'recording_removed': 'Recording removed',
        'restart': 'Restart session',
        'restart_confirm': 'Are you sure you want to restart this session? The current session will be terminated and a new one will start automatically.',
        'restart_success': 'Session restarted',
        'restart_error': 'Failed to restart session'
    },
    'timeshift_status': {
        'not_started': 'Not stated',
        'in_progress': 'In progress',
        'partial': 'Partial',
        'finished': 'Finished'
    },
    'worker_logs': {
        'level': 'Level',
        'time': 'Time',
        'trace_id': 'Trace ID',
        'span_id': 'Span ID',
        'span_name': 'Span Name',
        'attributes': 'Attributes',
        'message': 'Message',
        'log': 'Worker log',
        '25lines': 'Last 25 lines',
        'last1h': 'Last 1 hour',
        'last6h': 'Last 6 hours',
        'last12h': 'Last 12 hours',
        'last24h': 'Last 24 hours',
        'full': 'Full logs',
        'no_data': 'No data for the selected time period'
    },
    'global_drm': {
        'global_drm': 'Global DRM',
        'global_config': 'Global config',
        'edit_drm': 'Edit Global DRM',
        'settings': 'Global DRM settings',
        'config_enabled': 'Global Config enabled',
        'provider': 'Provider',
        'provider_iv': 'Provider IV',
        'provider_key': 'Provider Key',
        'password': 'Private Key Encryption Password',
        'service_certificate': 'Service Certificate',
        'encrypted_service_certificate': 'Encrypted Service Certificate Private Key',
        'dcsl_service_account': 'DCSL Service Accounts',
        'err_missing_files': 'Missing required files',
        'not_all_files_have_been_added': 'Not all files have been added',
        'disable_err': 'All channel DRMs must be disabled to disable global config',
        'crypto_period_seconds': 'Crypto period seconds'
    },
    'distribution_zone_channels': {
        'channel_name': 'Channel name',
        'session_worker': 'Worker',
        'session_active': 'Active Session',
        'session_duration': 'Session duration',
        'active_sessions': 'Active sessions',
        'reassign': 'Reassign all',
        'move_to_worker': 'Move to worker',
        'worker': 'Worker',
        'new_worker': 'New worker',
        'current_worker': 'Current worker',
        'no_workers': 'Currently no workers available in distribution zone',
        'channel_workers': 'Distribution zone channel workers',
        'auto_assign': 'Auto assigned'
    },
    'settings': {
        'settings': 'Settings',
        'update_data_in_typesense': 'Update data in Typesense',
        'force_sync': 'Force sync',
        'are_you_sure_you_want_to_update_all_data_in_typesense': 'Are you sure you want to update all data in typesense?',
        'success_updated_data': 'Successfully updated data',
        'error_sync_data': 'There was an error while sync data',
        'this_may_take_a_few_minutes': 'This may take a few minutes'
    }
}
